import {
    buildFileDownloadHref,
    fileExtensionMap,
    isValidFileType,
} from "../contentUtils";
import type {ChecklistFileItem, ChecklistRelatedItem} from "../types";

export const getFileDownloadInfo = (
    file: ChecklistFileItem,
    relatedItem: ChecklistRelatedItem | undefined,
) => {
    if (file.objectType !== "file") return null;
    if (!relatedItem || !isValidFileType(relatedItem.resourceTypeId))
        return null;

    return {
        href: buildFileDownloadHref(file.id),
        downloadName: `${file.subname}${fileExtensionMap[relatedItem.resourceTypeId] ?? ""}`,
        resourceTypeId: relatedItem.resourceTypeId,
    } as const;
};
